import ModuleLoader from "../modules/module.loader";
import { COOKIEMODALMOCK } from '../app.config';

export default class Modal {

	constructor(context, callback) {
    this.context = context;
    this.callback = callback;
    this.items = Array.from(context.querySelectorAll('[data-modal-toggle]'));
	}

  initCookieModal() {
    const isHome = document.body.classList.contains('homepage-page');
    const hasCookie = document.cookie.split(';').some((item) => item.trim().startsWith('modalClosed='));
    if(isHome && !hasCookie) {
      setTimeout(() => {
        this.mainView(typeof window.environment != 'undefined' &&
        typeof window.environment.assets != 'undefined' ? window.modal_json_suffix : "0");
        this.loadModule();
      }, 800)
    }
  }

  addListeners() {
    this.onToggleClick = this.clickHandler.bind(this);
    this.items.forEach((item) => item.addEventListener('click', this.onToggleClick));
  }

  removeListeners() {
    this.items.forEach((item) => item.removeEventListener('click', this.onToggleClick));
  }

  clickHandler(event) {
    event.preventDefault();
    this.mainView(event.currentTarget.dataset.modalToggle);
    this.loadModule();
  }

  mainView(id) {
    const main = document.createElement('div');
    main.className = 'modal';
    main.setAttribute('data-module', 'modal');
    main.setAttribute('data-modal-id', id );
    this.main = main;
  }

  loadModule() {
    document.body.appendChild(this.main);
    this.module = new ModuleLoader(this.main, document.body, this.moduleLoaded.bind(this))
  }

  moduleLoaded() {
    //window.client.scroller.stop();
  }

  static init(context) {
    Modal.item = new Modal(context);
    if(window.hp_modal_active || COOKIEMODALMOCK) {
      Modal.item.initCookieModal();
    }
    Modal.addAllListeners();
  }

  static addAllListeners() {
    Modal.item.addListeners()
  }

  static removeAllListeners() {
    Modal.item.removeListeners()
  }
}
